// extracted by mini-css-extract-plugin
module.exports = {"block":"block--mMYkj","button":"button--FGY5A","labels":"labels--d7_9B","tag":"tag--hNKGJ","statesblk":"statesblk--bM6JS","row":"row--JhllG","long":"long--l8KR5"};